import { Flate } from '../services/_globalContext/context';

/**
 * Converts a javascript object to ArrayBuffer using TextEncoder
 *
 * @param obj
 */
export default function compress(obj: any, flate: Flate): Uint8Array<ArrayBuffer> {
  const json = JSON.stringify(obj);

  const enc = new TextEncoder();
  const jsonBytes = enc.encode(json);

  // fflate types its output over ArrayBufferLike; it is a plain ArrayBuffer at
  // runtime, which is what Blob and fetch bodies are typed to accept.
  return flate.gzip_encode_raw(jsonBytes) as Uint8Array<ArrayBuffer>;
}

export function decompress(arrayBuffer: ArrayBuffer, flate: Flate) {
  const decompressed = flate.gzip_decode_raw(new Uint8Array(arrayBuffer));

  const dec = new TextDecoder();
  const json = dec.decode(decompressed);

  return JSON.parse(json);
}
